import { render, staticRenderFns } from "./mailings-input-status.vue?vue&type=template&id=5aab6952&"
import script from "./mailings-input-status.vue?vue&type=script&lang=js&"
export * from "./mailings-input-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports